import React from 'react';
import { Row, Col, Button, Card } from 'reactstrap';
import { Link } from 'react-router-dom';
import Dropzone from 'react-dropzone';
import Moment from 'react-moment';
import { Audit } from '../../../../../_metronic/helpers/components/Audit';
import ProductDetailImages from './ProductDetailImages';

const ProductImagesSection = ({ 
    intl,
    myFiles,
    images,
    onDropRejected,
    handleAcceptedFiles,
    onSaveFile,
    onDeleteFile,
    onDeleteExistFile,
    onSequenceDecrease,
    onSequenceIncrease,
    isEditing
}) => {
    
    if (!isEditing) {
        return <ProductDetailImages images={images} title={intl.formatMessage({ id: 'PRODUCT.IMAGES.TITLE' })} />
    }

    return (
        <div className='card mb-5 mb-xl-10'>
             <div className="card-header cursor-pointer">
                <div className="card-title m-0">
                    <h3 className="fw-bolder m-0">{intl.formatMessage({ id: 'PRODUCT.IMAGES.TITLE' })}</h3>
                </div>
            </div>
            <div className="card-body p-9">

                <Dropzone
                    onDrop={acceptedFiles => handleAcceptedFiles(acceptedFiles)}
                    onDropRejected={onDropRejected}
                    accept={['image/png', 'image/jpg', 'image/jpeg']}
                    multiple={true}
                    maxSize={20000000}>
                    {({ getRootProps, getInputProps }) => {
                        return (
                            <>
                                <div className="dropzone dz-clickable">
                                    <div className="dz-message needsclick" {...getRootProps()}>
                                        <input {...getInputProps()} />
                                        <i className="ki-duotone ki-file-up fs-3x text-primary"><span className="path1"></span><span className="path2"></span></i>
                                        <div className="ms-4">
                                            <h3 className="fs-5 fw-bold text-gray-900 mb-1">{intl.formatMessage({ id: 'PRODUCT.IMAGE.UPLOAD' })} </h3>
                                            <span className="fs-7 fw-semibold text-primary opacity-75">{intl.formatMessage({ id: 'PRODUCT.IMAGE.MAX' })}</span>
                                            <br></br>
                                            <span className="fs-7 fw-semibold text-primary opacity-75">{intl.formatMessage({ id: 'PRODUCT.IMAGE.FORMATS' })}</span>
                                        </div>
                                    </div>
                                </div>
                            </>
                        )
                    }}
                </Dropzone>

                <div className={"dropzone-previews mt-3"} id="file-previews">
                    {myFiles.map((f, i) => {
                        return (
                            <Card
                                className="mt-1 mb-0 shadow-none border dz-processing dz-image-preview dz-success dz-complete"
                                key={i + '-file'}>
                                <div className="p-2">
                                    <Row className="align-items-center">
                                        <Col className="col-auto">
                                            <img
                                                width={250}
                                                data-dz-thumbnail=""
                                                className="avatar-sm rounded bg-light"
                                                alt={f.file.name}
                                                src={f.file.preview}
                                            />
                                        </Col>
                                        <Col className="pl-0">
                                            <Link to="#" className="text-muted font-weight-bold">
                                                {f.file.name}
                                            </Link>
                                        </Col>

                                        <Col className="col-auto">
                                            <Button
                                                className="btn btn-icon btn-circle btn-active-success"
                                                onClick={() => onSaveFile(f.id)}>
                                                <i className="ki-duotone ki-check-circle fs-2x">
                                                    <span className="path1"></span>
                                                    <span className="path2"></span>
                                                    <span className="path3"></span>
                                                </i>
                                            </Button>
                                        </Col>

                                        <Col className="col-auto">
                                            <Button
                                                className="btn btn-icon btn-circle btn-active-danger"
                                                onClick={() => onDeleteFile(f.id)}>
                                                <i className="ki-duotone ki-cross-circle fs-2x">
                                                    <span className="path1"></span>
                                                    <span className="path2"></span>
                                                </i>
                                            </Button>
                                        </Col>
                                    </Row>
                                </div>
                            </Card>
                        );
                    })}
                </div>
            
                <div className='row mt-10'>
                    <div className='col-12'>
                        <h3 className="card-title mb-5">{intl.formatMessage({ id: 'PRODUCT.FIELD.RECOREDIMAGES' })}</h3>
                    </div>
                    {images && images.map((item, index) => {
                        return (
                            <div key={item.id} className='col-md-6 mb-5'>
                                <div className="card h-100 border">
                                    <Audit table="ProductImage" identifier={item.id} />
                                    <div className="card-body d-flex justify-content-center text-center flex-column p-4">
                                        <a href={item.link} download={true} target="_blank" className="text-gray-800 text-hover-primary d-flex flex-column">
                                            <div className="symbol symbol-100px mb-2">
                                                <img src={item.link} alt="" />
                                            </div>
                                        </a>
                                        <div className="d-flex flex-column align-items-center mt-4 w-100">
                                            <div className="mb-3">
                                                <div className="fs-8 fw-bold text-gray-500 mb-1 text-center">{intl.formatMessage({ id: 'PRODUCT.FIELD.SEQUENCE' })}</div>
                                                <div className="input-group input-group-sm" style={{width: '120px'}}>
                                                    <button className="btn btn-icon btn-outline btn-outline-dashed btn-active-light-primary btn-sm" type="button" onClick={() => { onSequenceDecrease(item) }}><i className="ki-duotone ki-minus fs-4"></i></button>
                                                    <input type="text" className="form-control text-center fw-bold" readOnly="readonly" value={item.sequence} />
                                                    <button className="btn btn-icon btn-outline btn-outline-dashed btn-active-light-primary btn-sm" type="button" onClick={() => { onSequenceIncrease(item) }}><i className="ki-duotone ki-plus fs-4"></i></button>
                                                </div>
                                            </div>
                                            <button type="button" className="btn btn-sm btn-light-danger w-100" onClick={() => onDeleteExistFile(item.id)}>
                                                <i className="ki-duotone ki-trash fs-3 me-1"></i> {intl.formatMessage({ id: 'GENERAL.DELETE' }) || 'Delete'}
                                            </button>
                                        </div>

                                    </div>
                                </div>
                            </div>
                        )
                    })}
                </div>
            </div>
        </div>
    );
};

export default ProductImagesSection;
